import { matchPath, useLocation } from 'react-router';
import styled, { useTheme } from 'styled-components';

import { useRegistrationBackground } from '#/hooks/useRegistrationBackground';
import { Path } from '#/service/routes';

const BackgroundImage = styled.div<{ image: string }>`
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-image: url(${({ image }) => image});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

// Using div over img because it's purely presentational and should fail silently / don't show the broken image icon.
export const PageBackground = () => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const { registrationBackgroundImage, shouldBlockGeneralBackground } =
    useRegistrationBackground();

  const image = registrationBackgroundImage ?? theme.pageBackgroundImage?.image;

  const isBlockedRoute = [Path.Details, Path.Playback].some((path) =>
    matchPath(path, pathname)
  );

  if (!image || isBlockedRoute || shouldBlockGeneralBackground) {
    return null;
  }

  return <BackgroundImage data-testid="pageBackgroundImage" image={image} />;
};
